document.addEventListener("DOMContentLoaded", ()=> {
    const infoCardIcons = document.querySelectorAll(".product-info-card-icon.show-on-mobile");
    if (infoCardIcons.length > 0) {
        infoCardIcons.forEach(infoCardIcon => {
            infoCardIcon.addEventListener("click", () => {
                if (infoCardIcon.dataset.iconLabel) {
                    const globalLabel = infoCardIcon.closest(".product-info-card-item").querySelector(".product-info-card-item-icon-label")
                    globalLabel.innerHTML = infoCardIcon.dataset.iconLabel;
                    globalLabel.style.display = "block";
                    globalLabel.closest(".product-info-card-item-icon-label-url").setAttribute("href", infoCardIcon.dataset.iconUrl);
                }
            })
        })
    }


    const infoCards = document.querySelectorAll(".product-info-card-item");
    if (infoCards.length > 0) {
        infoCards.forEach(infoCard => {
            infoCard.addEventListener("click", function(event) {
                if (!event.target.classList.contains('product-info-card-icon-img')) {
                    setTimeout(() => {
                        const globalLabel = infoCard.querySelector(".product-info-card-item-icon-label")
                        globalLabel.innerHTML = "";
                        globalLabel.style.display = "none";
                        globalLabel.closest(".product-info-card-item-icon-label-url").setAttribute("href", "");
                    }, 200)
                    
                }
            })
        })
    }
})
